export const filterReportsData = [
    {
        id: 1,
        title: "Пристрої та аксесуари від 1500",
        categories:
            "&category_ids[]=1&category_ids[]=13&category_ids[]=14&category_ids[]=16&category_ids[]=17&category_ids[]=18&category_ids[]=19&category_ids[]=15",
        price: [1500, ""],
    },
    {
        id: 2,
        title: "Аксесуари від 0 до 200",
        categories: "&category_ids[]=15",
        price: [0, 200],
    },
    {
        id: 3,
        title: "Аксесуари від 200 до 300",
        categories: "&category_ids[]=15",
        price: [20, 300],
    },
    {
        id: 4,
        title: "Аксесуари від 300 до 400",
        categories: "&category_ids[]=15",
        price: [300, 400],
    },
    {
        id: 5,
        title: "Аксесуари від 400 до 1500",
        categories: "&category_ids[]=15",
        price: [400, 1500],
    },

    {
        id: 6,
        title: "Всі аксесуари",
        categories: "&category_ids[]=15",
        price: [0, ""],
    },
    {
        id: 7,
        title: "Всі запчастини",
        categories: "&category_ids[]=21",
        price: [0, ""],
    },
    {
        id: 8,
        title: "Відображати все",
        categories: "",
        price: [0, ""],
    },
];

export const sortReportsData = [
    { title: "Сортувати по назві", value: "title", id: 1 },
    { title: "Сортувати по ціні", value: "price", id: 2 },
    { title: "Сортувати по даті", value: "created_at", id: 3 },
];
